import {api} from "api";
import {storage} from "utils";
import {close} from "../modal";
import {showAlert} from "../alert";
import {alertMessages} from "./helper";
import {toggleButtonLoaderId} from "../layout";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {thunkBadRequest} from "global/thunk-error";
import {
  LoginPayload,
  Authenticated,
  ForgotPasswordPayload,
  ChangePasswordPayload,
} from "interfaces";

export const login = createAsyncThunk(
  "auth/login",
  async (payload: LoginPayload, {rejectWithValue, dispatch}) => {
    dispatch(toggleButtonLoaderId("login"));

    try {
      const authenticated = await api.Post<Authenticated>(
        "/users/login",
        payload
      );
      dispatch(close());
      dispatch(showAlert(alertMessages["login"]));
      return authenticated;
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    } finally {
      dispatch(toggleButtonLoaderId("login"));
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgot-password",
  async (payload: ForgotPasswordPayload, {rejectWithValue, dispatch}) => {
    dispatch(toggleButtonLoaderId("forgot-password"));

    try {
      await api.Post<null>("/users/forgotpasswordAdmin", payload);
      dispatch(close());
      dispatch(showAlert(alertMessages["forgot-password"]));
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    } finally {
      dispatch(toggleButtonLoaderId("forgot-password"));
    }
  }
);

export const changePassword = createAsyncThunk(
  "auth/change-password",
  async (payload: ChangePasswordPayload, {rejectWithValue, dispatch}) => {
    dispatch(toggleButtonLoaderId("change-password"));

    try {
      await api.Post<null>("/users/changepassworAdminToken", payload);
      dispatch(showAlert(alertMessages["change-password"]));
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    } finally {
      dispatch(close());
      storage["delete"]("[auth-token]");
      dispatch(toggleButtonLoaderId("change-password"));
    }
  }
);
